import { render, staticRenderFns } from "./EditSubscriptionType.vue?vue&type=template&id=4f8a072c&"
import script from "./EditSubscriptionType.vue?vue&type=script&lang=js&"
export * from "./EditSubscriptionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports